import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import './HelpCategoryPage.css';

/**
 * Adding Friends and Contacts Article Page
 */
const AddingContacts = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <h1 className="lp-section-title">Create your first group</h1>
              <p className="lp-section-subtitle">
                Create a group to start splitting expenses with friends.
              </p>
              
              <div className="article-body">
                <p>
                  Groups make it easy to split expenses with the same people regularly. Create your
                  first group to get started.
                </p>
                
                <h2>Creating a Group</h2>
                <p>To create a new group:</p>
                <ol>
                  <li>Tap the "+" button or "Create Group" option</li>
                  <li>Give your group a name (e.g., "Apartment Expenses")</li>
                  <li>Add members by searching for contacts or inviting via link</li>
                  <li>Set group permissions and settings</li>
                  <li>Confirm and create the group</li>
                </ol>

                <h2>Group Settings</h2>
                <p>When creating a group, you can configure:</p>
                <ul>
                  <li>Group name and description</li>
                  <li>Member permissions (who can add expenses, manage settings, etc.)</li>
                  <li>Default split method (equal, custom, percentage)</li>
                  <li>Notification preferences</li>
                </ul>

                <h2>Inviting Members</h2>
                <p>
                  You can invite members by sending them a group link, searching for their username,
                  or adding them from your contacts. Members will receive a notification to join.
                </p>
              </div>

              <ArticleNavigation
                previous={{
                  title: 'Top up your account',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'top-up-account'))
                }}
                next={{
                  title: 'Manage your group',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'manage-group'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default AddingContacts;
